module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }